/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../app/services/SmartNamingSvc',
	'../../lib/@waca/core-client/js/core-client/utils/ClassFactory',
	'../../common/templates/HtmlTemplates'
], function(SmartNamingSvc, ClassFactory, HtmlTemplates) {

	/**
	*	Helper class used to create the core dashboard services and services registry
	*/
	class BoardLoaderHelper {

		constructor(dashboardApi) {
			this.dashboardApi = dashboardApi;
		}

		//TODO - migrate SmartNamingSvs to a feature
		createBoardServices(options) {
			const services = {};
			if (options.widgetRegistry){
				services.smartNamingSvc = new SmartNamingSvc(this.dashboardApi, options.widgetRegistry, options.boardModel);
				this.dashboardApi.registerDashboardSvc('.SmartNamingSvc', services.smartNamingSvc);
			}
			return services;
		}

		loadLayoutExtensions(layoutExtensions) {
			const promises = Object.keys(layoutExtensions.consumeViews || {})
				.map(key => {
					const path = layoutExtensions.consumeViews[key];
					return ClassFactory.loadModule(path)
						.then(ModuleClass => {
							return {
								key: key,
								template: ModuleClass.getTemplate
							};
						});
				});
			return Promise.all(promises);
		}

		registerLayoutExtensions(layoutExtensions) {
			const layoutExtensionsTemplates = {};
			layoutExtensions.forEach(function(layoutExtensions) {
				if (layoutExtensions.template) {
					layoutExtensionsTemplates[layoutExtensions.key] = layoutExtensions.template;
				}
			});
			const htmlTemplates = new HtmlTemplates({
				layoutExtensionsTemplates: layoutExtensionsTemplates
			});
			this.dashboardApi.registerDashboardSvc('htmlTemplates', htmlTemplates);
		}
	}
	return BoardLoaderHelper;
});
